// src/models/product.ts
var PRODUCT_TYPES = {
  COLLAGE_A: { shotCount: 8, printCount: 1, paperType: "collage_4x6" },
  COLLAGE_B: { shotCount: 16, printCount: 2, paperType: "collage_4x6" },
  STRIP_A: { shotCount: 8, printCount: 2, paperType: "strip" },
  STRIP_B: { shotCount: 16, printCount: 4, paperType: "strip" }
};

// src/models/branding.ts
var DEFAULT_BRANDING = {
  businessName: "Photo Booth",
  logos: {
    primary: "/assets/default-logo.png"
  },
  colors: {
    primary: "#ec4899",
    secondary: "#06b6d4",
    accent: "#eab308",
    background: "#fffbf5",
    surface: "#ffffff",
    text: "#1f2937",
    textMuted: "#6b7280"
  },
  fonts: {
    heading: "Nunito, sans-serif",
    body: "Poppins, sans-serif",
    display: "Nunito, sans-serif"
  },
  ui: {
    borderRadius: "large",
    buttonStyle: "gradient",
    cardStyle: "elevated",
    animationLevel: "playful"
  },
  assets: {},
  social: {},
  print: {
    watermarkEnabled: false,
    watermarkPosition: "bottom-right",
    watermarkOpacity: 30,
    qrCodeOnPrint: true
  }
};

// src/models/capture.ts
var DEFAULT_CAPTURE_CONFIG = {
  countdownSeconds: 5,
  reviewPhotoSeconds: 5,
  editCountdownSeconds: 600
  // 10 minutes
};

// src/api/common.ts
var ErrorCodes = {
  VALIDATION_ERROR: "E001",
  NOT_FOUND: "E002",
  UNAUTHORIZED: "E003",
  PAYMENT_FAILED: "E004",
  SYNC_CONFLICT: "E005",
  HARDWARE_ERROR: "E006",
  RATE_LIMITED: "E007",
  SERVER_ERROR: "E500"
};
export {
  DEFAULT_BRANDING,
  DEFAULT_CAPTURE_CONFIG,
  ErrorCodes,
  PRODUCT_TYPES
};
